import type { FaireProductEntity } from "../../entity_types/product";

export const p_yy3tvvbd9n: FaireProductEntity = {
  token: "p_yy3tvvbd9n",
  type: "product",
  name: "Baccarat 16 oz 100% Soy Candle",
  brandToken: "b_rnzbyn79fg",
  brandName: "Ember Water",
  imageUrl:
    "https://cdn.faire.com/fastly/4f51a362fdefab1b8a23d1a93e92bd15a1d650c27d29ae87b5d0dbe6c4ec6517.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1bb7e3f623f464ab590e0044ca670a3e996661ed0945dc66dc71b95b02301a87.png",
    "https://cdn.faire.com/fastly/82dbb4a2df674bee7272d96b133bcf0c49e6123a3e577f8eeb78b4cf121c0f73.png",
  ],
  priceDollars: 12,
  description:
    "Inspired by luxury scents, without the luxury price.\n\nA rich blend of jasmine & saffron, enveloped by the warmth of amberwood & ambergris. It is wove with woody tones of fresh cut cedarwood. The addition of saffron compliments the floral and woody notes. \n\nOur candles are made with 100% American soy wax phthalate-free fragrance oils + a lead-free cotton wicks. Each 16 oz candle burns for 70 hours. \n\n𝐂𝐚𝐧𝐝𝐥𝐞 𝐂𝐚𝐫𝐞:\n• Trim the carbon build up off your wicks before each new burn. If at any point you notice high flames/soot/smoke emitting from your candle, blow it out, trim the wicks + re-light.\n• To avoid tunneling, allow the candle to burn for a full 4 hours during the first burn. \n• Don't leave your candle burning for longer than 4 hours at a time. Do not allow candle to burn when there is less than a 1/4\" of wax remaining.\n• Keep away from children, pets, drafts, flammable objects and surfaces.\n\nAll products are made to order + we do our best to ship your order as quickly as possible.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:54.665Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
